import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  row: {
    // zIndex: 1,
    minWidth: "100%",
    width: "initial",
    // position: "relative",
    // borderRadius: 5,
    "& > .cell": {
      backgroundColor: theme.props.backgroundSecondary,
    },
    "&.d0": {
      "&:not(.summary) > .cell": {
        color: theme.props.text.alt,
        backgroundColor: theme.props.sectionColor,
      },
      "&.summary > .cell": {
        backgroundColor: "transparent",
      },
      "& hr": {
        backgroundColor: theme.props.text.alt,
      },
      "& .hoverIcon": {
        color: theme.props.text.alt,
      },
    },
    "& .hoverIcon": {
      opacity: 0.6,
    },
    "& .hoverIcon.opq": {
      opacity: 1,
    },
  },
  altBackground: {
    "& > .cell": {
      backgroundColor: theme.props.background + " !important"
    }
  },
  rowSelected: {
    "&.d1 .cell": { backgroundColor: theme.props.backgroundLevel1 },
    "&.d2 .cell": { backgroundColor: theme.props.backgroundLevel2 },
    "&.d3 .cell": { backgroundColor: theme.props.backgroundSecondary },
  },
  rowOff: {
    "& > .cell > *:not(.opaque):not(.opaque-tContent)": { opacity: 0.3 },
    "& > .cell > *.opaque-tContent": { borderColor: theme.props.border+"4D !important" },
    "& > .cell > *.opaque-tContent .tm-bar": { opacity: 0.3 },
  },
}));

export default useStyle;
